import { StatisticObjectEnum } from '@/Services/StatisticPermissionService';
import { Maybe } from '@/Types/Maybe';
import { RolePreviewResource } from '@/Types/roles';
import { SpClusterPreviewResource } from '@/Types/serviceProviderClusters';

import { DataType, PaginationType, QueryType } from '../base/types';

export type UserStatisticObject = {
    type: StatisticObjectEnum;
    id: number;
};

export type UserAccessObject = {
    type: AccessObjectTypeEnum;
    id: number;
};

export enum AccessObjectTypeEnum {
    STORE_GROUP = 'store_group',
    STORE = 'store',
}

export interface UsersQueryType extends QueryType {
    page?: number;
    per_page?: number;
    store_group_id?: number;
    company_id?: number;
    role_id?: number;
    status_id?: number;
}

export interface UserRequestType extends DataType {
    name: string;
    username: string;
    email: string;
    password: string;
    repeat_password?: string;
    company_id?: number;
    store_groups_ids?: number[];
    role_id?: number;
    status?: number;
    is_company_admin?: boolean;
    sp_cluster_id?: number | null;
    statistic_object?: Maybe<UserStatisticObject>;
    access_object?: Maybe<UserAccessObject>;
}

export interface GetAllUsersResponse {
    pagination: PaginationType;
    users: UserResource[];
}

/**
 * Same as user resource.
 *
 * TODO: move to @/types
 */
export interface UserResource {
    id: number;
    name: string;
    username: string;
    email: string;
    company: {
        id: number;
        name: string;
    };
    store_groups: [
        {
            id: number;
            name: string;
        }
    ];
    role: RolePreviewResource;
    status: {
        id: number;
        name: string;
    };
    is_company_admin: boolean;
    statistic_object: Maybe<UserStatisticObject>;
    access_object: Maybe<UserAccessObject>;
    sp_cluster: SpClusterPreviewResource | null;
}
